import React from 'react';

/**
 * DASH icon — official DeliverHealth DASH logo.
 *
 * Used as a drop-in mark anywhere DASH needs a visual identity:
 *   • chat assistant avatar (per-message)
 *   • chat panel header tile
 *   • hero card logo on the home page
 *
 * Renders the official PNG at /public/dash_logo.png.  Component API
 * (size / style / title) is stable so the logo can be swapped here
 * without touching any consumer.
 */
export default function DashMascot({ size = 48, style, title = 'DASH' }) {
  return (
    <img
      src="/dash_logo.png"
      alt={title}
      title={title}
      width={size}
      height={size}
      style={{
        display: 'block',
        flexShrink: 0,
        objectFit: 'contain',
        ...style,
      }}
    />
  );
}
